const suffixes = ['', 'k', 'm', 'b', 't'];

/**
 * Returns abbreviated number with unit suffix (e.g. 1100 -> 1.1k).
 */
const abbreviate = (value: number): string => {
    let shortValue = Math.abs(value);
    let suffixIndex = 0;

    while (shortValue >= 1000) {
        shortValue /= 1000;
        suffixIndex += 1;
    }

    // We are limited in space, so we want our abbreviated number to have small footprint. To achieve that, we omit
    // the fractional part if integer part has more than two digits. E.g. "23 100" will appear as "23.1k", but
    // "230 100" will be shown as "230k".
    if (shortValue / 100 > 1) {
        // Integer part is too lengthy, drop the fractional part.
        shortValue = Math.round(shortValue);
    } else {
        // We are interested in only one decimal place, so we need to round it properly.
        // parseFloat() is used to remove insignificant trailing zeros.
        shortValue = parseFloat(shortValue.toFixed(1));
    }

    return (value < 0 ? '-' : '') + shortValue.toString() + (suffixes[suffixIndex] ?? '...');
};

export default abbreviate;
